import React, { Component } from 'reactn'
import moment from 'moment'
import { Button, FormControl } from 'react-bootstrap'
import md5 from 'md5'
import { toast, Modal } from '../Components/ui'
import { DataTable } from '../Components/ui'
import Api from '../Services/Api'
import TableDetail from './TableDetail'
import { FiPlus, FiDownload } from 'react-icons/fi'

class Users extends Component {
  constructor (props) {
    super(props)
    this.state = {
      users: [],
      newUser: false,
      email: '',
      name: '',
      type: '...',
      soci: []
    }
  }

  async componentDidMount () {
    await this.loadData()
  }

  async loadData () {
    const res = await Api.get('/users')
    if (res.ok) {
      const _users = res.data.map(user => {
        let passwordTemp = ''
        if (user.firstLogin) {
          const hash = md5((user.email).toString())
          passwordTemp = hash.substring(hash.length - 8, hash.length)
        } else {
          passwordTemp = '******'
        }
        return { ...user, passwordTemp }
      })
      this.setState({ users: _users })
    } else {
      toast.error('Impossibile recuperare i dati degli utenti')
    }

    const { user } = this.global
    const ret = await Api.get('/aggregate/fornitori', { idUtente: user._id, skipUserSoci: true })
    this.setState({ soci: ret.data })
  }

  async registerNewUser () {
    const { email, name, type } = this.state
    if (!email || !name || type === '...') {
      toast.error('Si prega di verificare i dati inseriti prima di procedere')
      return
    }

    const hash = md5((email).toString())
    const password = hash.substring(hash.length - 8, hash.length)

    const res = await Api.post('/users', { email, password, name, type, firstLogin: true })
    if (res.ok) {
      toast.success('Utente registrato con successo')
      this.setState({ newUser: false, email: '', name: '', type: '...' })
      await this.loadData()
    } else {
      toast.error("Impossibile registrare l'utente, si prega di riprovare")
    }
  }

  exportCSV () {
    const { users } = this.state
    if (!users.length) return

    const headers = ['ID', 'Cod. Fornitore', 'Password Temp', 'Ragione Sociale', 'Tipo', 'Primo Login']
    const rows = users.map(u => [u._id, u.email, u.passwordTemp, u.name, u.type, u.firstLogin ? 'Sì' : 'No'])
    const csv = [headers, ...rows].map(row => row.map(cell => `"${(cell || '').toString().replace(/"/g, '""')}"`).join(',')).join('\n')

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `Utenti_${moment().format('YYYY-MM-DD')}.csv`
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
  }

  render () {
    const { users, newUser, email, name, type, soci } = this.state

    const columns = [
      { key: '_id', header: 'ID', accessor: '_id', width: '15%' },
      { key: 'email', header: 'Cod. Fornitore', accessor: 'email', width: '15%' },
      { key: 'passwordTemp', header: 'Password Temp', accessor: 'passwordTemp', width: '10%' },
      { key: 'name', header: 'Ragione Sociale', accessor: 'name', width: '35%' },
      { key: 'type', header: 'Tipo', accessor: 'type', width: '10%' },
      {
        key: 'firstLogin',
        header: 'Primo Login',
        accessor: 'firstLogin',
        width: '10%',
        render: val => val ? <span className='ui-badge ui-badge-open'>Sì</span> : null
      }
    ]

    return (
      <div className='page-fill'>
        <div className='ui-page-header'>
          <h3>Utenti</h3>
        </div>

        <div className='page-fill-body'>
          <DataTable
            data={users}
            columns={columns}
            searchable
            searchPlaceholder='Cerca utente per nome, codice fornitore...'
            pagination
            pageSize={15}
            fillHeight
            expandRow={row => <TableDetail data={row} soci={soci} loadData={() => this.loadData()} />}
            actions={
              <>
                <Button variant='outline-primary' size='sm' onClick={() => this.exportCSV()}>
                  <FiDownload style={{ marginRight: 4 }} /> Export CSV
                </Button>
                <Button variant='primary' size='sm' onClick={() => this.setState({ newUser: true })}>
                  <FiPlus style={{ marginRight: 4 }} /> Nuovo utente
                </Button>
              </>
            }
          />
        </div>

        <Modal
          isOpen={newUser}
          onClose={() => this.setState({ newUser: false })}
          title='Registrazione Nuovo Utente'
          width={480}
          footer={
            <Button variant='primary' onClick={() => this.registerNewUser()}>
              Registra utente
            </Button>
          }
        >
          <div className='ui-form-grid'>
            <div className='ui-field ui-col-12'>
              <label>Email / Codice Fornitore</label>
              <FormControl value={email} onChange={e => this.setState({ email: e.target.value })} />
            </div>
            <div className='ui-field ui-col-12'>
              <label>Nome / Ragione Sociale</label>
              <FormControl value={name} onChange={e => this.setState({ name: e.target.value })} />
            </div>
            <div className='ui-field ui-col-12'>
              <label>Tipo utente</label>
              <select className='form-select' value={type} onChange={e => this.setState({ type: e.target.value })}>
                <option value='...'>...</option>
                <option value='admin'>Admin</option>
                <option value='user'>User</option>
                <option value='tecnici'>Manutentore</option>
              </select>
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

export default Users
